import { EventEmitter, Input, Output } from '@angular/core';

export abstract class PermissionsBulkStepComponent {
  @Input() data: any;
  @Output() backCallback = new EventEmitter();
  @Output() submitCallback = new EventEmitter();

  loading = true;
}
